import type { QueryDataSetterUpdater } from "@src/hooks/useQueryData";
import { useQueryData } from "@src/hooks/useQueryData";
import {
    wsInplantsServices,
    type WsDepotCardExtends,
    type WsInplantContent,
    type WsInplantContentExtends,
} from "../../../../../api/wsInplants";

/** Связи строки состава, нужные именно UI карточки ВЗН. */
export const WS_INPLANT_CONTENT_CARD_LIST_INCLUDES = {
    include: ["LeaveCard", "ArrivalCard"] satisfies Array<keyof WsInplantContentExtends>,
    includeLeaveCard: ["Stockobj", "Measure"] satisfies Array<keyof WsDepotCardExtends>,
} as const;

export interface UseWsInplantContentsQueryResult {
    data: WsInplantContent[] | undefined;
    contents: WsInplantContent[];
    isFetching: boolean;
    refetch: () => Promise<unknown>;
    setData: (updater: QueryDataSetterUpdater<WsInplantContent[]>) => void;
}

/**
 * Server-state состава ВЗН на TanStack Query.
 */
export function useWsInplantContentsQuery(inplantCode: number): UseWsInplantContentsQueryResult {
    const query = useQueryData({
        queryKey: ["workshop", "wsInplant", inplantCode, "contents"],
        queryFn: async ({ signal }) => {
            const items = await wsInplantsServices.content.load(
                {
                    flt: { WsInplantCode: inplantCode },
                    ...WS_INPLANT_CONTENT_CARD_LIST_INCLUDES,
                },
                { signal },
            );
            return items;
        },
        enabled: inplantCode > 0,
        meta: { errorSource: "workshop.wsInplant.contents" },
    });

    return {
        data: query.data,
        contents: query.data ?? [],
        isFetching: query.isFetching,
        refetch: query.refetch,
        setData: query.setData,
    };
}
